import React from 'react';
import { Box } from '@mui/material';
import { AlertIcon } from '../../../../../../theme/icons';
import { Device } from '../../../../../../redux/commander/api/device.model';
import useCommanderStatus from '../../../../../../redux/commander/commander-status/hooks/useCommanderStatus';
import DeviceModel from '../../../../../../redux/commander/api/DeviceModel';
import { useGetMQTTDeviceConnection } from '../../../../../../redux/commander/hooks/useGetMQTTDeviceConnection';

interface NotificationIconProps {
  device: Device;
  isMobileDevice?: boolean;
}

export const NotificationIcon = ({
  device,
  isMobileDevice,
}: NotificationIconProps) => {
  const { isLoading, cloudConnectivityMQTT } =
    useGetMQTTDeviceConnection(device);
  const alertIcon = (
    <Box
      color={'warning.main'}
      display={'block'}
      position="absolute"
      top={!isMobileDevice ? '-1rem' : '0rem'}
      width={'0.5rem'}
      left={'0'}
    >
      <AlertIcon className="icon-unicolor" width={'1rem'} />
    </Box>
  );
  if (isLoading) {
    return null;
  }
  return !cloudConnectivityMQTT ? alertIcon : null;
};
